module.exports = __webpack_public_path__ + "img/Bravick.7e939cee.jpg";